// extracted by mini-css-extract-plugin
export var wordContainer = "_p0-0";